const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class AccountBenefitsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.observeForTabSelected()
  }

  observeForTabSelected () {
    document
      .querySelector('.drw-Account_Tab[data-type="register"]')
      .addEventListener('click', () => {
        this.carousel = this.setupCarousel()
      })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    let slidesPerView = 2.2

    if (
      this.getAttribute('data-account-benefits-carousel-images') === 'landscape'
    ) {
      slidesPerView = 1.1
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: slidesPerView,
          spacing: 5,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('account-benefits-carousel')) {
  customElements.define('account-benefits-carousel', AccountBenefitsCarousel)
}
